import backendHttpClient from '@services/_httpClient/backend.http-client';

import type { UpdateCompanyDto, UpdateCompanyPayload } from './dtos/update.dto';
import type { CompanyRepository } from './repository';
import type {
  GetCompanyByOwnerIdOutput,
  GetCompanyByOwnerIdResponse,
} from './types/getByOwnerId.type';
import type {
  UpdateCompanyOutput,
  UpdateCompanyResponse,
} from './types/update.type';

class CompanyService implements CompanyRepository {
  public async getByOwnerId(
    ownerId: string,
  ): Promise<GetCompanyByOwnerIdOutput> {
    const { data } = await backendHttpClient.get<GetCompanyByOwnerIdResponse>({
      path: `companies/${ownerId}`,
    });

    return { company: data.company };
  }

  public async update({
    id,
    ...dto
  }: UpdateCompanyPayload): Promise<UpdateCompanyOutput> {
    const { data } = await backendHttpClient.put<
      UpdateCompanyResponse,
      UpdateCompanyDto
    >({
      path: `companies/${id}`,
      body: dto,
    });

    return { company: data.company };
  }
}

export const companyService = new CompanyService();
